import React       from "react";
import View        from "./view";
import config      from "../../../config";
import MaskedInput from "react-text-mask";
import fetchJsonp  from "fetch-jsonp";
import "./form.css";

export default class ConfirmPhoneView extends View {
    static get title () {
        return "подтвердите номер телефона";
    }

    static get titleShort() {
        return "подтверждение";
    }

    static get bookingProps() {
        return [
            "specialization",
            "clinic",
            "doctor",
            "service",
            "date",
            "time",
            "lastname",
            "firstname",
            "middlename",
            "birthDate"
        ];
    }

    static get propTypes() {
        return {
            specialization: React.PropTypes.number.isRequired,
            clinic:     React.PropTypes.number.isRequired,
            doctor:     React.PropTypes.number.isRequired,
            service:    React.PropTypes.number.isRequired,
            date:       React.PropTypes.string.isRequired,
            time:       React.PropTypes.string.isRequired,
            lastname:   React.PropTypes.string.isRequired,
            firstname:  React.PropTypes.string.isRequired,
            middlename: React.PropTypes.string.isRequired,
            birthDate:  React.PropTypes.string.isRequired,
        };
    }

    static get contextTypes() {
        return {
            muiTheme: React.PropTypes.object,
        };
    }

    constructor(props) {
        super(props);

        this.state = Object.assign({}, this.state, {
            phone: "",
            isConfirmCodeVisible: false,
            confirmCode: "",

            errorsVisibility: {
                "phone": false,
                "confirmCode": false,
            },

            errors: {
                "phone": "",
                "confirmCode": ""
            }
        });

        this.phoneInputReference = null;
        this._isMounted = false;
    }

    validateForm() {
        const errorsVisibility = this.state.errorsVisibility;
        const errors = this.state.errors;

        for (const propertyName in this.state.errorsVisibility) {
            if (this.state.errorsVisibility.hasOwnProperty(propertyName)) {
                errorsVisibility[propertyName] = false;
            }
        }

        this.setState({
            errorsVisibility,
            errors
        });

        if (this.state.isConfirmCodeVisible === false) {
            if (this.state.phone.trim().length === 0) {
                errorsVisibility["phone"] = true;
                errors["phone"] = "Это поле обязательно для заполнения.";
                this.setState({
                    errorsVisibility,
                    errors
                });
                return;
            }

            /**
             * STEP 1 Get confirm code
             */
            this.getConfirmCode().then(() => {
                if (this._isMounted === true) {
                    this.setState({
                        isConfirmCodeVisible: true,
                    });
                }
            }).catch((error) => {
                if (this._isMounted === true) {
                    errorsVisibility["phone"] = true;
                    errors["phone"] = error.message;

                    this.setState({
                        errorsVisibility,
                        errors
                    });
                }
            });
        } else {
            /**
             * STEP 2. Validate confirm code.
             */
            this.validateConfirmCode().then((isCodeValid) => {
                /**
                 * STEP 3. Cancel confirm code.
                 */
                return this.bookPatient();
            }).then((receiptData) => {
                if (this._isMounted === true) {
                    this.props.gotoNextView({
                        breadcrumbName: "подтверждение",
                        nextView: "ReceiptView",
                        props: {
                            receiptData: receiptData,
                        }
                    });
                }
            }).catch((error) => {
                if (this._isMounted === true) {
                    errorsVisibility["confirmCode"] = true;
                    errors["confirmCode"] = error.message;
                    this.setState({
                        errorsVisibility,
                        errors
                    });
                }
            });
        }
    }

    handleButtonClick() {
        this.validateForm();
    }

    getConfirmCode() {
        return new Promise((resolve, reject) => {
            const phoneNumber = encodeURIComponent(this.state.phone);
            const url = `${config.baseUrl}/mobile-validation/submit-confirm-code-jsonp?phone=${phoneNumber}`;

            fetchJsonp(url).then((response) => {
                return response.json();
            }).then((responseJson) => {
                if (responseJson.status === true) {
                    resolve();
                } else {
                    reject(new Error(responseJson.description));
                }
            }).catch((error) => {
                reject(error);
            });
        });
    }

    validateConfirmCode() {
        return new Promise((resolve, reject) => {
            const phoneNumber = encodeURIComponent(this.state.phone);
            const confirmCode = encodeURIComponent(this.state.confirmCode);

            const url = `${config.baseUrl}/mobile-validation/check-confirm-code-jsonp?phone=${phoneNumber}&code=${confirmCode}`;
            fetchJsonp(url).then((response) => {
                return response.json();
            }).then((responseJson) => {
                resolve(responseJson.status);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    bookPatient() {
        return new Promise((resolve, reject) => {
            const url = `${config.baseUrl}/ajax/book-patient` +
                `?phone=${encodeURIComponent(this.state.phone)}` +
                `&code=${encodeURIComponent(this.state.confirmCode)}` +
                `&partnerId=${config.partnerId}`;

            const urlWithProps = ConfirmPhoneView.bookingProps.reduce((url, propName) => {
                return `${url}&${encodeURIComponent(propName)}=${encodeURIComponent(this.props[propName])}`;
            }, url);

            fetchJsonp(urlWithProps).then((response) => {
                return response.json();
            }).then((responseJson) => {
                if (responseJson.status === true) {
                    resolve(responseJson);
                } else {
                    reject(new Error(responseJson.description));
                }
            }).catch((error) => {
                reject(error);
            });
        });
    }

    renderErrorMessage(propertyName) {
        if (this.state.errorsVisibility[propertyName]) {
            return <div className="appointment-form__error">{this.state.errors[propertyName]}</div>;
        } else {
            return null;
        }
    }

    componentDidMount() {
        this._isMounted = true;
        if (this.phoneInputReference !== null) {
            this.phoneInputReference.inputElement.focus();
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleKeyPress(event) {
        if (event.key === "Enter") {
            this.validateForm();
        }
    }

    render() {
        const colors = this.context.muiTheme.palette;

        return (
            <div className="appointment-view appointment-view--confirm-phone">
                <div className="appointment-form">
                    {this.state.isConfirmCodeVisible === true ? <div className="appointment-form__text">
                        На Ваш номер было отправлено SMS с кодом подтверждения.
                        Для продолжения операции укажите код в поле ниже.
                    </div> : null}

                    <div className="appointment-form__element">
                        <label className="appointment-form__label"> Номер телефона </label>
                        <MaskedInput
                            style={{
                                backgroundColor: colors.primary3color
                            }}

                            mask={["+", "7", "(", /\d/, /\d/, /\d/, ")", /\d/, /\d/, /\d/, "-", /\d/, /\d/, "-", /\d/, /\d/]}
                            disabled={this.state.isConfirmCodeVisible}
                            required="true"
                            value={this.state.phone}
                            placeholder={"+7(___)___-__-__"}
                            onKeyPress={(value) => this.handleKeyPress(value)}
                            onChange={(event) => this.setState({ phone: event.target.value })}
                            ref={(reference) => {
                                this.phoneInputReference = reference;
                            }}
                            className="appointment-text-field" type="text" />

                        {this.renderErrorMessage("phone")}
                    </div>

                    {this.state.isConfirmCodeVisible === true ? <div className="appointment-form__element">
                        <label className="appointment-form__label"> Код подтверждения </label>
                        <MaskedInput
                            style={{
                                backgroundColor: colors.primary3color
                            }}

                            mask={[/\d/, /\d/, /\d/, /\d/]}
                            required="true"
                            value={this.state.confirmCode}
                            onKeyPress={(value) => this.handleKeyPress(value)}
                            onChange={(event) => this.setState({ confirmCode: event.target.value })}
                            className="appointment-text-field" type="text" />

                        {this.renderErrorMessage("confirmCode")}
                    </div> : null}

                    <div className="appointment-form__element">
                        <button
                            style={{
                                backgroundColor: colors.accent5color
                            }}

                            onClick={() => this.handleButtonClick()}
                            type="button"
                            className="appointment-form__button">
                            {this.state.isConfirmCodeVisible === true ? "записаться" : "получить код"}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/views/confirm-phone.js
 **/